export default {
  tableDataSmartLibraries: state => {
    return state.smartLibraryList
  },
  tableDataEforms: state => {
    return state.eFormList
  },
}
